import React from 'react';
import PageTitle from '../../layouts/PageTitle';

const PerformanceReport = () => {
    return (
        <div className='performanceReport'>

            <PageTitle
                title="Reports"
                subtitle="Performance Report"
            />
            <div className='date_select'>
                <select className='border-0' name="week" id="week" style={{ width: '60px' }}>
                    <option value="" selected>Today</option>
                    <option value="">Yesterday</option>
                    <option value="">This week</option>
                    <option value="">Last week</option>
                    <option value="">Custom</option>
                </select>
            </div>
            <div className='card-header top-portion mt-2 px-0'>
                <div className="row w-100 m-0">
                    <div className="col-md-6 col-lg-6">
                        <h3>Performance Report</h3>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <i className="mdi mdi-download mdi-24px"></i>
                        <i className="mdi mdi-send ml-3"></i>
                    </div>
                </div>
            </div>
            <table className='table table-bordered w-100'>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Orders</th>
                        <th>Cancelled</th>
                        <th>Sales</th>
                    </tr>
                </thead>
                <tbody>
                    <tr >
                        <td>5/5/2020</td>
                        <td>9</td>
                        <td>0</td>
                        <td><b>SGD 156.70</b></td>
                    </tr>
                    <tr>
                        <td>5/5/2020</td>
                        <td>8</td>
                        <td>0</td>
                        <td><b>SGD 156.70</b></td>
                    </tr>
                    <tr>
                        <td>5/5/2020</td>
                        <td>7</td>
                        <td>0</td>
                        <td><b>SGD 156.70</b></td>
                    </tr>
                    <tr>
                        <td>5/5/2020</td>
                        <td>6</td>
                        <td>0</td>
                        <td><b>SGD 156.70</b></td>
                    </tr>
                    <tr>
                        <td>5/5/2020</td>
                        <td>9</td>
                        <td>0</td>
                        <td><b>SGD 156.70</b></td>
                    </tr>
                    <tr>
                        <td>5/5/2020</td>
                        <td>2</td>
                        <td>0</td>
                        <td><b>SGD 156.70</b></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PerformanceReport;